var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGarage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.733,
    height: 28.172,
    viewBox: "0 0 30.733 28.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29103",
    d: "M50.593 484.348a.64.64 0 0 1-.64-.64v-17.57l-14.086-8.572-14.086 8.572v17.57a.64.64 0 0 1-1.281 0v-17.93a.64.64 0 0 1 .307-.547l14.726-8.961a.64.64 0 0 1 .666 0l14.726 8.961a.64.64 0 0 1 .307.547v17.93a.64.64 0 0 1-.639.64z",
    transform: "translate(-20.5 -456.176)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18072",
    transform: "translate(5.122 16.003)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.489,
    height: 7.683,
    rx: 1,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19.489,
    height: 6.683,
    rx: 0.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18068",
    transform: "translate(6.403 22.404)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.561,
    height: 3.842,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h1.561v2.842H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18069",
    transform: "translate(21.769 22.404)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.561,
    height: 3.842,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h1.561v2.842H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18070",
    transform: "translate(7.683 18.562)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.561,
    height: 2.561,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h1.561v1.561H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18071",
    transform: "translate(20.489 18.562)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.561,
    height: 2.561,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h1.561v1.561H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29104",
    d: "M41.955 469.183a.64.64 0 0 1-.593-.4l-2.457-6H27.294l-2.682 6.017a.64.64 0 0 1-1.17-.521l2.851-6.4a.64.64 0 0 1 .585-.38h12.457a.64.64 0 0 1 .593.4l2.62 6.4a.641.641 0 0 1-.592.883z",
    transform: "translate(-17.624 -451.898)",
    style: {
      fill: "gray"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.5a1e998a82361a0f149e8a435ba5cdf0.svg";
export { ForwardRef as ReactComponent };